<!--
  @description 数据配置
  @author xiehan
  @date 2018/12/11
-->
<template>
  <div class="dataConfig__content">
    <source-group 
      @data-source-skip="skipTo" 
      :is-delete="true" 
      :is-add="true">
    </source-group>
  </div>
</template>

<script>
  import sourceGroup from '@/views/component/sourceGroup'
  export default {
    components: {
      sourceGroup
    },
    methods: {
      skipTo (info) {
        if (info.group !== 'others') {
          this.$message({
            message: this.$t('dataConfig.sourceTips'),
            type: 'warning'
          })
          return
        }
        this.$router.push({ name: 'handlerDataConfig', query: { id: info.id } })
      }
    }
  }
</script>

<style>

</style>